module.exports = "/dist/assets/images/arrow-pink.svg";